import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import TaxActions from '@Actions/taxActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const TaxForm = ({
  user, getTaxTypes, getTaxTypesLoading, createTaxLoading, updateTaxLoading, callback, createTax, updateTax, taxTypes, group, taxes, selectedTax, getTaxes,
}) => {
  const [taxName, setTaxName] = useState('');
  const [taxValue, setTaxValue] = useState('');
  const [taxType, setTaxType] = useState('');
  const [description, setDescription] = useState('');
  // const [isEditable, setIsEditable] = useState(false);
  const [childTaxIds, setChildTaxIds] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');

  useEffect(() => {
    getTaxTypes(user?.tenant_info?.org_id);

    if (selectedTax) {
      setTaxName(selectedTax?.tax_name);
      setTaxValue(String(selectedTax?.tax_value));
      setTaxType(selectedTax?.tax_type);
      setDescription(selectedTax?.description);
      // setIsEditable(selectedTax?.is_editable);
      setChildTaxIds(selectedTax?.child_taxes?.map((item) => item?.tax_id));
    }
    if (group) {
      getTaxes(user?.tenant_info?.org_id, null, 1000, null, false);
    }
  }, []);

  const handleTax = () => {
    setFormSubmitted(true);
    if (taxName && taxValue && taxType && (group ? childTaxIds?.length > 0 : true)) {
      const payload = {
        org_id: user?.tenant_info?.org_id,
        tax_id: selectedTax?.tax_id || null,
        tax_name: taxName,
        tax_value: taxValue,
        tax_type: taxType,
        description,
        is_group: !!group,
      };
      if (group) {
        payload.child_tax_ids = childTaxIds?.map((id) => String(id));
      }
      if (selectedTax) {
        updateTax(payload, () => {
          callback();
        });
      } else {
        createTax(payload, (createdUom) => {
          if (callback) callback(createdUom);
        });
      }
    }
  };

  const getChildTaxesData = (taxesData) => {
    let taxData = JSON.parse(JSON.stringify(taxesData || []));
    const currentTaxType = taxTypes?.data?.tax_types?.find((item) => item?.tax_type_id === taxType);
    if (user?.tenant_info?.country_code === 'IN') {
      if (currentTaxType?.tax_type_name === 'GST') {
        taxData = taxesData?.filter((item) => !item?.is_group_tax_type && (item?.parent_tax_type === 'GST' || item?.parent_tax_type === null) && !item?.is_document_level);
      } else {
        taxData = taxesData?.filter((item) => !item?.is_group_tax_type && item?.parent_tax_type !== 'GST' && !item?.is_document_level);
      }
    }
    return taxData;
  };

  return (
    <Fragment>
      <div className="tax-form__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24">
            <H3FormInput
              name="Tax name"
              type="text"
              containerClassName="orgInputContainer create-tax-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setTaxName(event.target.value)}
              value={taxName}
              label="Tax Name"
              maxlength="100"
              required
              showError={formSubmitted && !taxName}
              disabled={createTaxLoading || updateTaxLoading || getTaxTypesLoading || (selectedTax && !selectedTax?.is_editable)}
            />
          </div>
          <div className="ant-col-md-24">
            <H3FormInput
              name="Tax value"
              type="text"
              containerClassName="orgInputContainer create-tax-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setTaxValue(event.target.value)}
              value={taxValue}
              label="Tax Value"
              maxlength="100"
              required
              showError={formSubmitted && !taxValue}
              disabled={createTaxLoading || updateTaxLoading || getTaxTypesLoading || (selectedTax && !selectedTax?.is_editable)}
            />
          </div>

          <div className="ant-col-md-24">
            <div className="orgInputContainer create-tax-input">
              <div className="orgFormLabel">Tax Type</div>
              <PRZSelect
                value={taxType}
                onChange={(value) => setTaxType(value)}
                disabled={createTaxLoading || updateTaxLoading || getTaxTypesLoading || (selectedTax && !selectedTax?.is_editable)}
              >
                {taxTypes?.data?.tax_types?.filter((item) => (item?.country_code === user?.tenant_info?.country_code) && !item?.is_document_level && (group ? item?.is_group_tax_type : !item?.is_group_tax_type)).map((item) => <Option key={item?.tax_type_id} value={item?.tax_type_id}>{item?.tax_type_name}</Option>)}
              </PRZSelect>
            </div>
          </div>

          {group && (
            <div className="ant-col-md-24">
              <div className="orgInputContainer create-tax-input">
                <div className="orgFormLabel">Child Taxes</div>
                <PRZSelect
                  mode="multiple"
                  value={childTaxIds}
                  onChange={(value) => {
                    const setChildTaxIdsArr = [];
                    for (let i = 0; i < value?.length; i++) {
                      setChildTaxIdsArr.push(value[i]);
                    }
                    setChildTaxIds(setChildTaxIdsArr);
                    setSearchKeyword('');
                  }}
                  filterOption={false}
                  disabled={createTaxLoading || updateTaxLoading || getTaxTypesLoading || (selectedTax && !selectedTax?.is_editable)}
                  maxTagCount="responsive"
                  onSearch={(value) => {
                    setSearchKeyword(value);
                  }}
                >
                  {getChildTaxesData(taxes?.data)?.filter((item) => (searchKeyword ? item?.tax_name?.toUpperCase()?.includes(searchKeyword?.toUpperCase()) : true))?.map((item) => <Option key={item?.tax_id} value={item?.tax_id}>{item?.tax_name}</Option>)}
                </PRZSelect>
              </div>
            </div>
          )}

          <div className="ant-col-md-24">
            <H3FormInput
              type="text"
              containerClassName="orgInputContainer create-tax-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setDescription(event.target.value)}
              value={description}
              label="Description"
              maxlength="200"
              disabled={createTaxLoading || updateTaxLoading || getTaxTypesLoading || (selectedTax && !selectedTax?.is_editable)}
            />
          </div>
        </div>

        <div className="custom-drawer__footer">
          <div className="ant-col-md-6">
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text={selectedTax ? 'Update Tax' : 'Add Tax'}
              onClick={() => handleTax()}
              isLoading={createTaxLoading || updateTaxLoading || getTaxTypesLoading}
              disabled={createTaxLoading || updateTaxLoading || getTaxTypesLoading}
              style={{
                width: '160px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, TaxReducers }) => ({
  user: UserReducers.user,
  createTaxLoading: TaxReducers.createTaxLoading,
  updateTaxLoading: TaxReducers.updateTaxLoading,
  getTaxTypesLoading: TaxReducers.getTaxTypesLoading,
  taxTypes: TaxReducers.taxTypes,
  taxes: TaxReducers.taxes,
});

const mapDispatchToProps = (dispatch) => ({
  getTaxTypes: (orgId) => dispatch(TaxActions.getTaxTypes(orgId)),
  createTax: (payload, callback) => dispatch(TaxActions.createTax(payload, callback)),
  updateTax: (payload, callback) => dispatch(TaxActions.updateTax(payload, callback)),
  getTaxes: (orgId, page, limit, isActive, isTaxGroup) => dispatch(TaxActions.getTaxes(orgId, page, limit, isActive, isTaxGroup)),
});

TaxForm.propTypes = {
  user: PropTypes.any,
  createTaxLoading: PropTypes.bool,
  createTax: PropTypes.func,
  callback: PropTypes.any,
  taxTypes: PropTypes.any,
  selectedTax: PropTypes.any,
  taxes: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TaxForm));
